import * as React from 'react'
import HvacChecklistForm from 'components/pg-forms/HvacChecklistForm'

const EmbedForm = ({ form }) => {
	switch (form.form.formId) {
		case '4e686c31-6b34-4c84-9117-06495aee2952':
			return <HvacChecklistForm title={form.title} {...form.form} />

		default:
			return <p>Form not set</p>
	}
}

export default EmbedForm
